import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const SortDescIcon: FC<SVGProps<SVGSVGElement>> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="100%" height="100%" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.83332 1.0022L4.49999 4.35097L1.16666 1.0022" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};